import React, { useEffect, useState } from 'react';
import { Col, Form, Image, Row } from 'react-bootstrap';
import { ASSET_URL } from '../../constant';

function CardCheckout(props) {
    const { data } = props;

    const [Qty, setQty] = useState(data.qty)

    useEffect(() => {
        setQty(data.qty)
    }, [data])

    // const mainImage = JSON.parse(data.product.image);
    // use Default Categories Photo
    const mainImage = JSON.parse(props.data.image)[0].url != "images/default-image-products.jpg" ?
        JSON.parse(props.data.image)[0].url :
        JSON.parse(props.data.category.thumbnail)[0].url;

    return (
        <Row className="border border-1 p-3 bg-white">
            <Col lg={2} className="align-self-center">
                <Image src={ASSET_URL + mainImage} className="w-75 d-block m-auto" />
            </Col>
            <Col lg={8}>
                <div className="cart-product-detail">
                    <p className="fs-5 fw-bold text-uppercase">{data.name}</p>
                    <div className="cart-desc" dangerouslySetInnerHTML={{__html: data.description}} />
                    <p className="text-secondary">MI ITEM # {data.item_no}</p>
                    <p className="text-secondary">MFR # {data.manufacture_no}</p>
                </div>
            </Col>
            <Col lg={2} className="align-self-center">
                <div className="cart-qty-wrapper">
                    <span className="fs-6">
                        Qty
                    </span>
                    <Form>
                        <Form.Group className="input-group">
                            <Form.Control type="number"
                                name="qty"
                                autoComplete="off"
                                value={Qty}
                                disabled
                                readOnly
                            />
                        </Form.Group>
                    </Form>
                </div>
            </Col>
        </Row>
    )
}

export default CardCheckout
